import { render, staticRenderFns } from "./DdianSpecification.vue?vue&type=template&id=b8e050ce&scoped=true"
import script from "./DdianSpecification.vue?vue&type=script&lang=js"
export * from "./DdianSpecification.vue?vue&type=script&lang=js"
import style0 from "./DdianSpecification.vue?vue&type=style&index=0&id=b8e050ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e050ce",
  null
  
)

export default component.exports